import React from 'react';

function TopStrip() {
  return (
    <div className="top-strip bg-dark text-white py-1">
      <div className="container">
        <div className="row align-items-center" style={{ fontSize: '12px' }}>
          {/* Left Side */}
          <div className="col-md-6 text-center text-md-start mt-1">
            <strong>Now Hiring</strong> : Are you a driven and motivated 1st Line DevOps Support Engineer?
          </div>

          {/* Right Side */}
          <div className="col-md-6 text-end mt-1 d-flex justify-content-center justify-content-md-end flex-wrap gap-3">
            {/* Support Email */}
            <a href="mailto:support@ddevops.com" className="text-white text-decoration-none d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope me-2" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1.586l-8 5.333-8-5.333V4z" />
                <path d="M0 6.414v5.586a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6.414l-8 5.333-8-5.333z" />
              </svg>
              support@ddevops.com
            </a>

            {/* Customer Login */}
            <a href="https://dashboard.ddevops.com/login/" className="text-white text-decoration-none d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-box-arrow-in-right me-2" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M6 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h-1V3H7v10h6v-2h1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3z" />
                <path fillRule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708L9.172 5.464a.5.5 0 0 0-.708.708L10.293 8l-1.829 1.828a.5.5 0 0 0 .708.708l2.682-2.682z" />
              </svg>
              Customer Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopStrip;
